module.exports = __webpack_public_path__ + "static/network3-422163c9ccbf1f772168615c41428251.jpg";